import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Img, { ImgProps } from "@insite/mobius/Img";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    prop65WarningMessage = "prop65WarningMessage",
    prop65WarningImage = "prop65WarningImage",
}

type Props = WidgetProps & HasProduct;


export interface ProductDetailsProp65Styles {
    prop65WarningWrapper?: InjectableCss;
    prop65WarningImage?: ImgProps;
    prop65WarningMessage?: TypographyPresentationProps;
}

export const productDetailsProp65Styles: ProductDetailsProp65Styles = {
    prop65WarningWrapper:{
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    prop65WarningImage: {
        css: css`
            max-width: 58px;
            max-height: 48px;
            flex: 10%;
            padding: 5px;
        `,
    },
    prop65WarningMessage:{
        css: css`
            flex: 90%;
            padding: 5px;
        `,
    },
};

const styles = productDetailsProp65Styles;

const prop65WarningMessage: React.FC<Props>  = ({ product, fields}) => {

    if(!product.properties.displayProp65Warning){
        return null;
    }

    if(product.properties.displayProp65Warning.toLowerCase() !== "true" || fields.prop65WarningMessage === ""){
        return null;
    }

    return (
        <StyledWrapper {...styles.prop65WarningWrapper}>
            <Img src={fields.prop65WarningImage} alt="Proposition 65 Warning Image" {...styles.prop65WarningImage}/>                       
            <Typography {...styles.prop65WarningMessage}>{parse(fields.prop65WarningMessage, parserOptions)}</Typography>
        </StyledWrapper>
    );
};


const widgetModule: WidgetModule = {
    component: withProduct(prop65WarningMessage),
    definition: {
        displayName: "Proposition 65 Warning",
        group: "Product Details",
        fieldDefinitions: [
            {
                name: fields.prop65WarningMessage,
                displayName: "Proposition 65 Warning Message",
                editorTemplate: "RichTextField",
                defaultValue: "This product can expose you to chemicals which are known to the State of California to cause cancer and birth defects or other reproductive harm. For more information, go to <a href='http://www.p65warnings.ca.gov' target='_blank'>www.p65warnings.ca.gov</a>",
                fieldType: "General",
                sortOrder: 1,
            },
            {
                name: fields.prop65WarningImage,
                displayName: "Proposition 65 Warning Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 2,
            },
        ],
    },
};



export default widgetModule; 